/**
 * Page Visibility + HTTP storm latch helpers for SWR poll hygiene.
 * When the tab is hidden or storm latch is armed, refresh / reconnect should pause.
 */

import { isHttpStormLatched } from '../http/httpStormDetectedLatch.js';

export function isAdminDocumentHidden(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.visibilityState === 'hidden' || document.hidden === true;
}

/**
 * Compose local pause predicates with document visibility and HTTP storm latch (G6 SoT).
 * Returns true when any predicate is true, the document is hidden, OR storm is latched.
 * Feature hooks that override provider `isPaused` must use this so reconnect does not
 * schedule while latched.
 */
export function composeAdminSwrIsPaused(
  ...predicates: ReadonlyArray<() => boolean>
): () => boolean {
  return (): boolean => {
    if (isAdminDocumentHidden() || isHttpStormLatched()) {
      return true;
    }
    return predicates.some((predicate) => predicate());
  };
}
